import { Notification } from '@/data/datatypes/Notification';

export function sortNotifications(a: Notification, b: Notification): number {
  return a.timestamp.getTime() - b.timestamp.getTime();
}
